/** @todo Fix import cycle */
/* eslint-disable import/no-cycle */

import * as Sentry from '@sentry/react'
import { action } from 'mobx'
import { createContext } from 'react'

import { refreshAccessToken as refreshAccessTokenService } from '@/services/user.service'

import { course } from './CourseStore'
import { tasks } from './TaskStore'
import { user } from './UserStore'

export class RootStore {
  user = user

  tasks = tasks

  course = course

  clearStore = action(() => {
    this.tasks.reset()
    this.user.reset()

    Sentry.setUser(null)
  })

  triggerRefreshToken = action(async (failedRequest) => {
    try {
      const { access, refresh } = await refreshAccessTokenService(this.user.refreshToken)
      this.user.accessToken = access
      this.user.refreshToken = refresh
      // Reassign to `failedRequest` as this object is used by the token
      // interceptor to retry the request
      // eslint-disable-next-line no-param-reassign
      failedRequest.response.config.headers.Authorization = `Bearer ${access}`
    } catch (err) {
      // Only log out the user if the server explicitly rejected the refresh token.
      // Network errors (server unreachable) should not cause a logout.
      const isAuthFailure =
        err.response?.status === 401 || err.response?.data?.code === 'token_not_valid'

      if (isAuthFailure) {
        this.clearStore()
      }
      throw err
    }
  })
}

export const store = new RootStore()
export const RootStoreContext = createContext(store)
